import React, { useCallback } from 'react'
import { FormikProps } from 'formik'

import InviteCarriersComponent from 'components/InviteCarriers'

import Step from '../Step'
import { Group } from '../styles'
import { FormValue } from '../types'

interface Props {
  formikProps: FormikProps<FormValue>
}

export default function InviteCarriers({ formikProps }: Props) {
  const {
    setFieldValue,
    values: { invitedCarriers },
  } = formikProps
  const handleCarrierChange = useCallback(
    (carrier: Carrier, isSelected: boolean) => {
      if (!isSelected) {
        setFieldValue('invitedCarriers', [...invitedCarriers, carrier])
      }
      if (isSelected) {
        setFieldValue(
          'invitedCarriers',
          invitedCarriers.filter(({ id }) => id !== carrier.id)
        )
      }
    },
    [invitedCarriers, setFieldValue]
  )

  return (
    <Step
      title="Who do you want to invite to bid?"
      subtitle="You can do this later. The invitation to the bid will be automatically send to their email."
    >
      <Group>
        <InviteCarriersComponent
          selectedCarriers={invitedCarriers}
          toggleCarrier={handleCarrierChange}
        />
      </Group>
    </Step>
  )
}
